<!-- 企业资质 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_about.jpg"
      class="banner"
    />
    <div class="breadcrumb w1200">
      <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
    </div>
    <sub-nav :subNavs="subNavs"></sub-nav>
    <div class="container w1200">
      <sub-title title="企业资质" en="ENTERPRISE QUALIFICATION"></sub-title>
    </div>
    <div class="box">
      <div class="item" v-for="item in list" :key="item.id">
        <img :src="URL + item.imgUrl" alt="" class="post" />
        <div class="desc">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import { URL } from "../../util/config";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      URL,
      routerHistory: [], // 当前所在位置
      subNavs: [],
      queryParams: {
        honorType: 0,
      },
      list: [],
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.formatBreadCrumb();
    this.getList();
  },
  mounted() {},
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find(
        (ele) => ele.path != "/" && this.$route.path.includes(ele.path)
      );
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
    async getList() {
      let res = await this.$api.getCertification(this.queryParams);
      this.list = res.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 30px;
  }
  .box {
    width: 1070px;
    margin: 0 auto 100px;
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
    column-count: 2;
    column-gap: 0;

    .item {
      width: 500px;
      break-inside: avoid;

      .post {
        width: 100%;
        height: auto;
      }
      .desc {
        height: 100px;
        padding-top: 20px;
        box-sizing: border-box;
        font-size: 24px;
        color: #5e5d5d;
        text-align: center;
      }
    }
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .box {
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;
      margin-bottom: 20px;

      .item {
        width: auto;

        .desc {
          height: 60px;
          padding-top: 10px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
